var Utils = {

	scrollTo: function(top) {
	    $('html, body').animate({
			scrollTop: top
		}, 500);

		return false;
	}

}